import { StreamUserFilterType } from '@/__generated__/graphql.ts';
import {
  getPersistedState,
  persistState,
} from '@/state-utils/persisted-state.ts';

export const StreamUserType = {
  ...StreamUserFilterType,
  Invites: 'INVITES',
} as const;
export type StreamUserType =
  (typeof StreamUserType)[keyof typeof StreamUserType];

const getStreamUsersKey = (id: string) => `stream-${id}-users-type`;

let streamUsersType: StreamUserType;

export const getStreamUsersType = (
  id: string,
  defaultType?: StreamUserType,
) => {
  const key = getStreamUsersKey(id);

  if (!streamUsersType) {
    streamUsersType = getPersistedState(
      key,
      StreamUserType,
      defaultType ?? StreamUserType.Followers,
    ) as StreamUserType;
  }
  return streamUsersType;
};

export const setStreamUsersType = (id: string, streamUsers: StreamUserType) => {
  const key = getStreamUsersKey(id);
  streamUsersType = streamUsers;

  persistState(key, streamUsersType);
};
